import React from "react";
import CommonInput from "../../../components/forms/CommonInput";
import CommonSelect from "../../../components/forms/CommonSelect";
import CommonButton from "../../../components/buttons/CommonButton";
import { handleChange } from "../../../helpers/handleFormChanges";
import { AppContext } from "../../../contexts/AppContext.jsx";
import CommonSwal from "../../../components/Swal/commonSwal.jsx";
import Dataprocess from "../../../helpers/DataProcess.js";
import PropTypes from "prop-types";

function PerfilCardContent({ valuesHook, salvarPerfil }) {
  const { baseUrl, session } = React.useContext(AppContext);
  const { values, setValues } = valuesHook;

  const handleChangeImage = async (e, data, setData) => {
    const file = e.target.files ? e.target.files[0] : "";
    const allowedExtensions = /(\.jpg|\.png)$/i;

    if (!allowedExtensions.exec(file && file.name)) {
      setData({
        ...data,
        [e.target.name]: "",
        imagePreview: "",
      });
      return CommonSwal({
        title: "Por favor, selecione uma imagem.",
      }).then(() => {
        e.target.value = "";
      });
    }

    var imagem = await Dataprocess.cortarImagem(e.target.files[0], 127, 127);

    setData({
      ...data,
      [e.target.name]: imagem.arquivo,
      imagePreview: imagem.preview,
    });
  };

  const unsetImagem = () => {
    setValues({
      ...values,
      imagePreview: null,
      imagemPerfil: null,
    });
  };

  return (
    <>
      <div className="row align-items-center justify-content-center">
        <div
          className="col-md-2 mb-3 text-center"
          style={{ maxWidth: "fit-content" }}
        >
          <img
            src={
              values.imagePreview
                ? values.imagePreview
                : values.imagemPerfil ||
                  `${baseUrl}assets/images/users/avatar.png`
            }
            alt="Avatar Usuário"
            className="img-thumbnail rounded-circle"
          />
          <input
            type="file"
            id="imagemPerfil"
            name="imagemPerfil"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => handleChangeImage(e, values, setValues)}
          />
          <div
            className="col"
            style={{
              marginTop: "-30px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <button
              className="btn bg-white rounded-circle"
              style={{ boxShadow: "inset 0 0 0 3px #f8f8f8" }}
              onClick={unsetImagem}
            >
              <i className="fas fa-trash text-danger"></i>
            </button>
            <button
              className="btn bg-white rounded-circle"
              style={{ boxShadow: "inset 0 0 0 3px #f8f8f8" }}
              onClick={() => {
                document.getElementById("imagemPerfil").click();
              }}
            >
              <i className="fas fa-camera"></i>
            </button>
          </div>
        </div>
        <div className="col-md mb-3">
          <CommonInput
            label="Nome do usuário"
            id="nome"
            value={values.nome}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-md mb-3">
          <CommonInput
            label="E-mail"
            id="email"
            type="email"
            value={values.email}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
          />
        </div>
        <div className="col-md mb-3">
          <CommonSelect
            label="Tipo do usuário"
            id="usuarioNivel"
            value={values.usuarioNivel}
            disabled={session.codigo !== "99"}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={[
              { id: "0", text: "Cliente" },
              { id: "99", text: "Administrador" },
            ]}
            placeholder="Selecione o nível do usuário"
          />
        </div>
      </div>
      <div className="row justify-content-end">
        <CommonButton onClick={salvarPerfil} color="success">
          Salvar
        </CommonButton>
      </div>
    </>
  );
}

PerfilCardContent.propTypes = {
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  salvarPerfil: PropTypes.func.isRequired,
};

export default PerfilCardContent;
